import React from 'react';
import { useNavigate } from 'react-router-dom';

import cs from 'classnames';

import Icon from './shared/Icon/Icon';
import Button from './shared/Button/Button';

/**
 * @param {object} props
 * @param {string} [props.portal] Path segment the action button navigates to
 * @param {string} [props.className]
 * @param {boolean} [props.isDark]
 * @param {string} [props.title] Heading, defaults to the generic page-level copy
 * @param {string} [props.description] Body copy under the heading
 * @param {string} [props.buttonText] Label for the action button
 */
const NotFound = ({
  portal = 'portal',
  className,
  isDark,
  title = 'Page not found',
  description = 'This page could not be found. Return to the dashboard to continue.',
  buttonText = 'Back to dashboard'
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => navigate(`/${portal}`);

  return (
    <div
      className={cs(
        'relative z-10 flex h-full flex-col content-center items-center justify-center gap-11',
        className
      )}>
      <Icon icon="illustration-not-found" />
      <div className="flex flex-col items-center">
        <h1
          className={cs(
            'text-2xl font-500 leading-[30px]',
            isDark ? 'text-white' : 'text-primary-900'
          )}>
          {title}
        </h1>
        <p
          className={cs(
            '!pt-2 font-400 leading-6',
            isDark ? 'text-neutral-dark-300' : 'text-neutral-600'
          )}>
          {description}
        </p>
        <Button
          text={buttonText}
          style="outlined"
          variant="link"
          icon="dashboard-mono"
          iconSize={18}
          size="small"
          className="!mt-6 !py-2 !pl-4 !pr-4"
          onClick={handleNavigate}
        />
      </div>
    </div>
  );
};

export default NotFound;
